"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEventBus = void 0;
const tiny_emitter_1 = require("tiny-emitter");
const utils_1 = require("../utils");
class GlobalEventBusEmitter extends tiny_emitter_1.TinyEmitter {
    constructor() {
        super(...arguments);
        this.debugLogger = new utils_1.DebugLogger('GlobalEventBus');
    }
    emit(event, ...args) {
        this.debugLogger.log(`Emitting event: "${event}" with arguments:`, args);
        return super.emit(event, ...args);
    }
    on(event, callback, ctx) {
        this.debugLogger.log(`Registering listener for event: "${event}"`);
        return super.on(event, callback, ctx);
    }
    once(event, callback, ctx) {
        this.debugLogger.log(`Registering one-time listener for event: "${event}"`);
        return super.once(event, callback, ctx);
    }
    off(event, callback) {
        this.debugLogger.log(`Removing listener for event: "${event}"`);
        return super.off(event, callback);
    }
}
if (!window.globalEventBus) {
    window.globalEventBus = new GlobalEventBusEmitter();
}
class GlobalEventBus {
    static on(event, callback) {
        window.globalEventBus.on(event, callback);
    }
    static once(event, callback) {
        window.globalEventBus.once(event, callback);
    }
    static off(event, callback) {
        window.globalEventBus.off(event, callback);
    }
    static emit(event, ...args) {
        window.globalEventBus.emit(event, ...args);
    }
}
exports.GlobalEventBus = GlobalEventBus;
